/**
 * Global variables
 *
 * @type {Element}
 */
let ctaButton = null;
let ctaAmountElement = null;
let ctaPrefixElement = null;
let priceChanged = false;

/**
 * Listen to click on the accordion toggle
 *     - update aria attribute
 *     - update 'open' attribute
 */
export default function radiosAccordionInit() {
  const accordions = document.querySelectorAll('.radio-accordion');
  if (!accordions) return;

  ctaButton = document.querySelector('.inpage-nav__cta--anfrage');
  if (ctaButton) {
    ctaAmountElement = ctaButton.querySelector('.inpage-nav__cta-amount');
    ctaPrefixElement = ctaButton.querySelector('.inpage-nav__cta-prefix');
  }

  accordions.forEach((accordion) => {
    accordion.panel = accordion.querySelector('.accordion__panel');
    accordion.content = accordion.querySelector('.accordion__content');
    accordion.toggle = accordion.querySelector('.radio-accordion__toggle');
    accordion.radio = accordion.querySelector('.radio-accordion__radio');
    accordion.state = false;
    accordion.addEventListener('click', () => {
      accordion.radio.checked = true;
      updateAccordionCheckedState(accordions);
    });
  });

  updateAccordionCheckedState(accordions);
}

/**
 * Update price on the inpage nav CTA Button
 *
 * @param checkedAccordion
 */
function updateCtaPrice(checkedAccordion) {
  const newPrice = checkedAccordion.querySelector('.radio-accordion__price-amount').textContent;
  if (!newPrice) return;
  if (ctaPrefixElement) ctaPrefixElement.remove();
  ctaAmountElement.textContent = newPrice;
}

/**
 * Update accordion UI according to the state
 *
 * @param accordion
 */
function updateAccordionUI(accordion) {
  accordion.radio.checked
    ? accordion.setAttribute('open', '')
    : accordion.removeAttribute('open');

  accordion.content.setAttribute("aria-expanded", accordion.state);
  accordion.panel.setAttribute("aria-expanded", accordion.state);
}

/**
 * Toggle 'ischecked' class on the container so we can style it when the child input is checked
 *
 * @param accordions
 */
function updateAccordionCheckedState(accordions) {
  accordions.forEach((accordion) => {
    if (accordion.radio.checked) {
      accordion.setAttribute('ischecked', '')
      if (ctaButton && priceChanged) {
        updateCtaPrice(accordion)
      }
    } else {
      accordion.removeAttribute('ischecked');
    }
    updateAccordionUI(accordion);
  });
}
